import React, { FC } from 'react';
import { SelectProps } from 'antd';

import { Select } from '~/components';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

const LegalTypeSelect: FC<SelectProps<any>> = (props) => {
  const handbook = useHandbook();
  const handbookKeys = useHandbookKeys();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === handbookKeys.legalType)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue!, key: item.key }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  return <Select showSearch {...props} options={[ { label: 'Other', value: 'OTHER' }]} />;
};

export default LegalTypeSelect;
